import React, {Fragment, useContext} from 'react'

import PropTypes from 'prop-types'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeAccordion, {moleculeAccordionBehavior} from '@s-ui/react-molecule-accordion'
import IconAccordionCollapsed from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'
import IconAccordionExpanded from '@adv-mt/mt-svg-icons/lib/ChevronUp.js'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {AccordionListItem} from './AccordionListItem.js'
import {BASE_CLASS, LIST_TYPES} from './settings.js'
import {SpecsList} from './specsList.js'

export const GroupedSpecsList = ({groupedSpecifications, listType}) => {
  const {i18n} = useContext(Context)
  const isAccordionsListType = listType === LIST_TYPES.accordion

  const groupedListClass = `${BASE_CLASS}-groupedList`
  const groupedListTitleWrapperClass = `${groupedListClass}TitleWrapper`

  return groupedSpecifications.map(({key, value = [], icon: Icon}, index) => {
    const hasSpecs = Boolean(value.length)

    if (hasSpecs && isAccordionsListType) {
      return (
        <div className={`${BASE_CLASS}-accordion`}>
          <MoleculeAccordion
            as={Fragment}
            behavior={moleculeAccordionBehavior.MULTIPLE}
            headerIconCollapsed={<IconAccordionCollapsed size={ATOM_ICON_SIZES.medium} />}
            headerIconExpanded={<IconAccordionExpanded size={ATOM_ICON_SIZES.medium} />}
          >
            <AccordionListItem label={i18n.t(key)}>
              <SpecsList specifications={value} isTable />
            </AccordionListItem>
          </MoleculeAccordion>
        </div>
      )
    }

    return hasSpecs ? (
      <div className={groupedListClass} key={index} data-testid={key}>
        <div className={groupedListTitleWrapperClass} key={index}>
          <Icon size="medium" />
          <TitleBasic as={titleBasicTags.h3} size={titleBasicSizes.xs} title={i18n.t(key)} />
        </div>
        <SpecsList specifications={value} />
      </div>
    ) : (
      <></>
    )
  })
}

GroupedSpecsList.propTypes = {
  listType: PropTypes.object,
  specifications: PropTypes.object
}
